import { get } from 'mobx'
import { useObserver } from 'mobx-react-lite'
import { useBrandOverviewPageStore } from 'store/context'

export function useTopBrandRecommendations(categoryId: string) {
  const flyOutBrandRecommendations = useBrandOverviewPageStore(
    store => store.flyOutBrandRecommendations,
  )
  const topBrandRecommendationIds: string[] = useObserver(() => {
    try {
      return get(flyOutBrandRecommendations, categoryId) || []
    } catch (e) {
      return flyOutBrandRecommendations[categoryId]
    }
  })

  return { topBrandRecommendationIds }
}
